import React from 'react';
import PropTypes from 'prop-types';

import PortalProvider from '../PortalProvider';

const ToastProvider = ({ children, isOpen, containerId }) =>
	!!isOpen && (
		<PortalProvider containerId={containerId}>{children}</PortalProvider>
	);

ToastProvider.propTypes = {
	children: PropTypes.node.isRequired,
	containerId: PropTypes.string.isRequired,
	isOpen: PropTypes.bool.isRequired,
};

export default ToastProvider;
